import {
  Option,
  Pagination,
} from "@deere/fuel-react";
import {
  FormControl,
  Grid,
  InputLabel, MenuItem,
  Select
} from "@mui/material";
import React from "react";
import {avgSprdMrgPct, formatDate} from "../../utilities/utils";
import {getUserObj, hasRole} from "../../utilities/tp-validations";
import {DATA_ENTRY, SALES_PERSON_ROLE} from "../../utilities/constants";

function SearchTablePagination(props) {
  const handleChangeRowsPerPage = (event) => {
    const rowsPerPage = +event.target.value;
    const updatedSearchObj = {
      ...props.searchObj,
      rowsPerPage,
      pageNo: 1,
    };
    props.setSelectedTransactions([]);
    props.setSearchObj(updatedSearchObj);
    handleSearchTransaction(updatedSearchObj);

  };

  const handleSearchTransaction = async (searchObj) => {
    const isSalesPerson = hasRole(SALES_PERSON_ROLE, props);
    const isDataEntryUser = hasRole(DATA_ENTRY, props);
    const userDetails = getUserObj(props);
    const updatedSearchObj = {
      ...searchObj,
    };
    if (searchObj.fromDate) {
      updatedSearchObj.fromDate = formatDate(searchObj.fromDate);
    }
    if (searchObj.toDate) {
      updatedSearchObj.toDate = formatDate(searchObj.toDate);
    }
    if(searchObj.avgSprdPct){
      updatedSearchObj.avgSprdPct = avgSprdMrgPct(searchObj.avgSprdPct)
    }
    if(isSalesPerson){
      updatedSearchObj.salePersonID = userDetails.userId;
    }
    if(isDataEntryUser){
      updatedSearchObj.createByUser = userDetails.userId;
    }
    try {
      await props.fetchSearchTransactions(updatedSearchObj);
    } catch (error) {
      console.error("handleSearchTransaction ", error);
    }
  };
  const handleChangePage = (event, newPageNo) => {
    const updatedSearchObj = {
      ...props.searchObj,
      pageNo: newPageNo,
    };
    props.setSearchObj(updatedSearchObj);
    handleSearchTransaction(updatedSearchObj);
  };


  return (
      <React.Fragment>
        <Grid sx={{ padding: "10px",display : "flex" }}>
          <FormControl
              sx={{
                display: "inline-flex",
                flexDirection: "row",
                alignItems: "center",
              }}
          >
          <InputLabel
              id="selectItemsPerPage-select-label"
              sx={{
                color: "#666666",
                fontSize: ".875rem",
                fontWeight: "normal",
                padding: "0px 10px",
              }}
          >
            {props.texts.TRANS_PER_PAGE}
          </InputLabel>
          <Select
              id="txns-per-page-select-field"
              value={props.searchObj?.rowsPerPage ?? 10}
              sx={{ width: "auto" }}
              MenuProps={{
                PaperProps: { sx: { maxHeight: 250} },
              }}
              onChange={handleChangeRowsPerPage}
          >
            <MenuItem key="10" value="10" selected>
              10
            </MenuItem>
            <MenuItem key="20" value="20">
              20
            </MenuItem>
            <MenuItem key="50" value="50">
              50
            </MenuItem>
            <MenuItem key="100" value="100">
              100
            </MenuItem>
          </Select>
          </FormControl>
          <Pagination
              sx={{ marginLeft: "auto" }}
              count={
                props.searchTransactionResponse &&
                props.searchTransactionResponse.pageDetails &&
                props.searchTransactionResponse.pageDetails.pageCount
                    ? Math.ceil(
                    Number(
                        props.searchTransactionResponse.pageDetails.pageCount
                    ) / props.searchObj?.rowsPerPage
                    )
                    : 0
              }
              page={props.searchObj?.pageNo}
              onChange={handleChangePage}
              breakpoint={900}
              showFirstButton={true}
              showLastButton={true}
          />
        </Grid>
      </React.Fragment>
  );
}

export default SearchTablePagination;
